import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN || 'https://318a9f84ab13d39699032c8f9217f38b@o4511586971680768.ingest.de.sentry.io/4511671147954256';
const environment = process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || 'production';
const release = process.env.REACT_APP_SENTRY_RELEASE || `aura-frontend@${process.env.REACT_APP_VERSION || '1.0.0'}`;

if (!dsn) {
  // eslint-disable-next-line no-console
  console.warn('[Sentry] REACT_APP_SENTRY_DSN is not set. Errors will only be logged locally.');
}

Sentry.init({
  dsn,
  environment,
  release,
  // Do not send personally identifiable information by default.
  sendDefaultPii: false,
  // Capture 100% of errors so nothing reported via WhatsApp is missed again.
  sampleRate: 1.0,
  // Performance/tracing kept low to control noise/cost.
  tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ?? 0.1),
  // Replay: capture 10% of sessions and 100% of sessions where an error occurs.
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Attach stack traces for console.error calls.
  attachStacktrace: true,
  // Normalize paths so source maps match later.
  normalizeDepth: 10,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: true,
    }),
  ],
  beforeSend(event) {
    // Drop common non-actionable browser noise.
    const ex = event.exception?.values?.[0];
    const type = ex?.type;
    const value = ex?.value;
    if (type === 'AbortError') return null;
    if (value?.includes('ResizeObserver loop limit exceeded')) return null;
    if (value?.includes('Network Error') && event.level === 'error') {
      // Keep network errors but downgrade to warning unless they crash the app.
      event.level = 'warning';
    }
    return event;
  },
});

// Extra safety net for errors that Sentry's default handlers may not catch
// (e.g. errors thrown in some third-party scripts). addEventListener is used
// so we don't overwrite any other onerror/onunhandledrejection handlers.
window.addEventListener('error', (event) => {
  Sentry.captureException(event.error ?? new Error(String(event.message)), {
    tags: { source: 'window.error' },
    extra: { source: event.filename, lineno: event.lineno, colno: event.colno },
  });
});

window.addEventListener('unhandledrejection', (event) => {
  Sentry.captureException(event.reason, {
    tags: { source: 'window.unhandledrejection' },
  });
});

export default Sentry;
